import { useContext } from "react";
import { SiteContext } from "../contexts/SiteContext";

export function useSiteContext() {
  return useContext(SiteContext);
}